import React, { useEffect, useState } from "react";
import "../CoursesList/coursesList.scss";
import TestSeriesLoader from "../common/loaders/TestSeriesLoader";
import { useDispatch, useSelector } from "react-redux";
import { useAutoClearSearchQuery, useSearchQuery } from "../../services/SearchQueryContext";
import NotFound from "../../pages/NotFound";
import { ReactComponent as SearchIcon } from "../../assets/images/search.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/close.svg";
import CoursesCard from "../CoursesCard/CoursesCard";
import { certificateListAction } from "examsbook-react-sdk/actions/certificateAddResponse";
import { useDebounce, useTranslations } from 'examsbook-react-sdk/custom-hooks';
import { Box, Button, Input, makeStyles } from "@material-ui/core";
import { getCourseList } from "examsbook-react-sdk/actions";

function CourseList(props) {
    useAutoClearSearchQuery();
    const [ selectedTab, setSelectedTab ] = useState(1);
    const [ contentData, setContentData ] = useState("");
    const dispatch = useDispatch();
    const t = useTranslations();
    const [ certificateListing, setCertificateListing ] = useState([]);
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const classes = useStyles(isFirefox);

    const user = useSelector((state) => state.user);
    const userId = user?.user?._id ? user?.user?._id : user?._id;
    const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
    const { searchQuery, setSearchQuery } = useSearchQuery();
    const courseListState = useSelector(state => state.courseList);
    const debouncedSearch = useDebounce(searchQuery, 500);
    const { isLoading, totalCount } = courseListState;
    const courseLength = 20;
    const courseList = useSelector((state) => state.courseList.data || []);
    const [hasMoreData, setHasMoreData] = useState(true);
 
    const handleScroll = (event) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        if (scrollHeight - scrollTop === clientHeight && hasMoreData) {
            const skipCount = contentData?.length || 0;
            if (courseLength <= totalCount) {
                fetchCoursesOnSearch(userId, skipCount, courseLength, debouncedSearch);
            }
        }
    };

    useEffect(() => {
        if (userId !== undefined) {
            setHasMoreData(true); // Reset this on new search
            fetchCoursesOnSearch(userId, 0, courseLength, debouncedSearch);
        }
    }, [debouncedSearch]);

    const fetchCoursesOnSearch = async (userId, skip = 0, courseLength = 20, search = "") => {
        try {
            const res = await dispatch(getCourseList(userId, skip, courseLength, search));
            const newData = res?.data || [];
            const sortedData = res?.data?.sort((a, b) => new Date(b.created.on) - new Date(a.created.on));
            if (skip === 0) {
                setContentData(sortedData);
            } else {
                setContentData(prev => [...prev, ...sortedData]); // Infinite scroll
            }
            if (newData.length === 0 || newData.length < courseLength) { // If no data returned, prevent calling api again and again
                setHasMoreData(false);
            }
        } catch (error) {
            console.error("Failed to fetch course list:", error);
        }
    };
    
    useEffect(() => {
        getCertificateListingData();
        clearField();
    }, []);


    function clearField(searchQuery) {
        if (searchQuery?.length) {
            setSearchQuery("");
        }
    }

    useEffect(() => {
        return () => {
            localStorage.removeItem('selectedTab');
        };
    }, []);

    const getCertificateListingData = async () => {
        try {
            dispatch(certificateListAction()).then((res) => {
                setCertificateListing(res?.data);
            });
        } catch (error) {
            console.error(error.message);
        }
    };

    function renderList() {
        return (
            <React.Fragment>
                {selectedTab === 1 && (
                    <>
                        <Box className="main-div">
                            <Box className="course-search-box">
                                <Input
                                    className="inner-search-box"
                                    style={{ border: "none" }}
                                    type="text"
                                    placeholder={t('Search')}
                                    value={searchQuery}
                                    onChange={(event) => setSearchQuery(event.target.value)}
                                />
                                <Box className="course-search-img-box">
                                    {searchQuery.length ? (
                                        <Button
                                            onClick={() => clearField(searchQuery)}
                                            style={{ border: "none" }}
                                        >
                                            <CrossIcon className="cross-icon" alt="Cross Icon"/>
                                        </Button>
                                    ) : (
                                        <SearchIcon className="search-icon" alt="Search Icon"/>
                                    )}
                                </Box>
                            </Box>

                            <Box className="card-list-div" onScroll={handleScroll}>
                                {isLoading && (!courseList || courseList.length === 0) ? (
                                    renderLoader()
                                ) : courseList && courseList.length > 0 ? (
                                    <Box className="card-view-new test-series-new ">
                                        {courseList.map((data, index) => (
                                            <CoursesCard
                                                key={index}
                                                testData={data}
                                                dueDateinDays={data?.dueDateinDays}
                                                settingsData={settingsData}
                                                certificateListing={certificateListing}
                                            />
                                        ))}
                                    </Box>
                                ) : !isLoading && courseList && courseList.length === 0 && (
                                    <Box className={classes.centerAlign}><NotFound/></Box>
                                )}
                            </Box>
                        </Box>
                    </>
                )}
            </React.Fragment>
        );
    }

    function renderLoader() {
        return (
            <Box className="card-view test-series">
                {Array.from({ length: 8 }).map((_, index) => (
                    <TestSeriesLoader key={index} />
                ))}
            </Box>
        );
    }

    return (
        <React.Fragment>
            {renderList()}
        </React.Fragment>
    );
}

const useStyles = makeStyles(() => ({
    centerAlign: isFirefox => ({
        textAlign: isFirefox ? '-moz-center' : '-webkit-center',
    }),
}));
export default CourseList;
